'use client';

import { useState, useEffect } from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { getJwtFromBiletoUserCookie, shouldShowProfileCompletionBanner } from 'utils/decodeJwt';
import { buildCompletionRedirectUrl } from 'utils/buildCompletionRedirectUrl';
import CompleteDataBottomSheet from './CompleteDataBottomSheet';

function CompleteDataBottomSheetWrapper() {
  const [isOpen, setIsOpen] = useState(true);
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  const completionBannerParams = useFeatureValue('discovery-next-completion-banner-params', {
    active: false,
    deadline: '',
    completionPercentage: 0,
    redirectUrl: ''
  });

  useEffect(() => {
    const token = getJwtFromBiletoUserCookie();
    const shouldShow = shouldShowProfileCompletionBanner(token);
    setShouldShowBanner(shouldShow);

  }, []);


  if (!shouldShowBanner || !completionBannerParams.active) return null;

  return (
    <CompleteDataBottomSheet
      isOpen={isOpen}
      deadline={completionBannerParams.deadline}
      completionPercentage={completionBannerParams.completionPercentage}
      onComplete={() => {
        window.location.href = buildCompletionRedirectUrl({
          redirectUrl: completionBannerParams.redirectUrl,
          currentUrl: window.location.href
        });
      }}
      onDismiss={() => setIsOpen(false)}
    />
  );
}

export default CompleteDataBottomSheetWrapper;
